export default function daysBetween(dateOne, dateTwo) {
  const differenceInMS = dateOne - dateTwo;
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const differenceInDays = differenceInMS / millisecondsPerDay;
  return Math.abs(Math.floor(differenceInDays));
}
